<template lang="pug">
div
    app-modal-visualizar-completo(
        v-if="showModalVisualizarProcesso && idProcesso !== null",
        @closeModal="showModalVisualizarProcesso = false",
        :idProcesso="idProcesso",
        :protocolo="protocolo",
        :numeroProcesso="numeroProcesso",
        :tipo="tipoProcesso"
    )
    el-card.card-container(shadow="hover")
        filtro(
            @pesquisar="pesquisar",
            @limpar="clear",
            :showOs="true",
            :showMunicipios="true",
            :configuracaoFiltro="configuracaoFiltro",
            :filtroRapido="filtroRapido"
        )
    app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :hasFiltroRapido="true",
    :filtro="filtro",
    @atualizarFiltro="atualizarFiltro",
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selected="false"
    )
</template>

<script>
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppListagem from '@/components/AppListagem'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
const { filtro } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('PROCESSOS_ASSINADOS'),
      idProcesso: null,
      processo: {},
      showModalVisualizarProcesso: false,
      items: [],
      protocolo: '',
      tipoProcesso: '',
      totalElements: 0,
      showModalResponsavel: false,
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroSituacao?.AGUARDANDO_DISPONIBILIDADE_TITULO || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 5, titulo: 'Situação', propriedade: 'status', ordem: 6, acoes: [] },
        {
              id: 6, titulo: 'Ações', propriedade: 'tipo', ordem: 7, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso },
            { id: 2, nome: 'Acusar Disponibilidade', icone: 'fa-check', codigo: 'ACUSAR_DISPONIBILIDADE', ordem: 2, show: this.showAcusarDisponibilidade }
          ]
        }
      ],
      filtroRapido: null
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  async created () {
    this.init()
  },

  watch: {
    async '$route' (to, from) {
      this.init()
    }
  },

  methods: {
    ...mapActions({
      acusarDisponibilidade: 'processo/acusarDisponibilidade'
    }),
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.setDadosProcesso(item)
      this.showModalVisualizarProcesso = true
    },
    atualizarFiltro (novoFiltro) {
      this.filtroRapido = novoFiltro
    },
    setDadosProcesso (item) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.processo = item
      this.protocolo = item.numeroProtocolo
      this.tipoProcesso = item.tipoCodigo
      this.processo = item
    },
    ACUSAR_DISPONIBILIDADE (_this, { item }) {
      try {
        this.acusarDisponibilidade(item.id)
        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, this.$messages.TITULO_DISPONIVEL.replace('$$', 'DIGEF'))
      } catch (err) {
        this.showNotificacao('error', 'Erro!', 'Ocorreu um erro, tente novamente mais tarde.')
      }
    }
  }
}
</script>
    <style lang="scss" scoped>
    .card-container {
      margin: 20px;
      border-radius: 10px;
    }
    </style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaProcessosAssinadosListagem.vue